exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".actions a {\n  white-space: nowrap;\n}\n\n.controls {\n  margin-top: 2em;\n}\n\n.filter {\n  margin-right: 1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.css
// module id = 852
// module chunks = 1